import { BLANK_SYMBOL } from "../constants";
import type { UserFragment } from "../graphql";
import { formatTags } from "./tags";

export function formatUsername(
  user?: Pick<UserFragment, "username" | "email" | "fullName"> | null
) {
  if (!user) return BLANK_SYMBOL;

  return user.username || user.fullName || user.email;
}

export function formatFullname(
  user?: Pick<UserFragment, "username" | "email" | "fullName"> | null
) {
  if (!user) return BLANK_SYMBOL;

  return user.fullName || user.username || user.email;
}

export function formatTenants(user: UserFragment) {
  return formatTags(
    user.tenants.map((t) => t.fullName),
    "cyan"
  );
}
